'use client'
import { ContactUsForm } from '@/components'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import React, { useEffect, useRef, useState } from 'react'

function NewsDetailsPage({ newsDetails }) {
   const [category, setCategory] = useState([])
   const [selectedCategory, setSelectedCategory] = useState('')
   const router = useRouter()
   const [showDropdown, setShowDropdown] = useState(false)
   const categoryContainerRef = useRef(null)
   const [categoryLoading, setCategoryLoading] = useState(true)
   const dropdownRef = useRef(null)

   useEffect(() => {
      function handleClickOutside(event) {
         if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
         ) {
            setShowDropdown(false)
         }
      }

      if (showDropdown) {
         document.addEventListener('mousedown', handleClickOutside)
      }

      return () => {
         document.removeEventListener('mousedown', handleClickOutside)
      }
   }, [showDropdown])

   useEffect(() => {
      if (newsDetails?.news_detail?.news_type) {
         setSelectedCategory(newsDetails?.news_detail?.news_type)
      } else {
         setSelectedCategory('')
      }
      return () => {}
   }, [newsDetails])

   const getCategoryNews = async () => {
      try {
         setCategoryLoading(true)
         const response = await fetch(
            `${process.env.NEXT_PUBLIC_NEWS_ROOM_BACKEND_URL}/news/types/`
         )
         const data = await response.json()
         setCategory(data.data)
      } catch (error) {
         setCategory([])
         setCategoryLoading(false)
         console.error('Error fetching news:', error)
      } finally {
         setCategoryLoading(false)
      }
   }
   const toggleDropdown = () => setShowDropdown(!showDropdown)

   const visibleCategories = category.slice(0, 6)
   const overflowCategories = category.slice(6)

   useEffect(() => {
      getCategoryNews()
      return () => {}
   }, [])

   const onSetLocalData = (data) => {
      localStorage.setItem('news-cat', data)
      router.push('/news-room')
   }

   const onRedirect = (id) => {
      router.push(`/news-room/${id}`)
   }

   return (
      <>
         <section className="section_theme_2_bg first-section news-card-section">
            <div className="news-container">
               {!categoryLoading && (
                  <div className="news-cat-section" ref={categoryContainerRef}>
                     <div
                        className={`news-cat-wrap ${
                           selectedCategory === '' ? 'active' : ''
                        }`}
                        onClick={() => {
                           setSelectedCategory('')
                           onSetLocalData('')
                        }}
                     >
                        <span>All</span>
                     </div>
                     {visibleCategories.map((item, i) => (
                        <div
                           className={`news-cat-wrap ${
                              selectedCategory === item ? 'active' : ''
                           }`}
                           key={i}
                           onClick={() => {
                              setSelectedCategory(item)
                              onSetLocalData(item)
                           }}
                        >
                           <span>{item}</span>
                        </div>
                     ))}
                     {overflowCategories.length > 0 && (
                        <div className="news-cat-wrap" ref={dropdownRef}>
                           <div className="dropdown">
                              <div
                                 onClick={toggleDropdown}
                                 className="dropdown-toggle"
                              >
                                 More
                              </div>
                              {showDropdown && (
                                 <div className="dropdown-menu news-more-opt show">
                                    {overflowCategories.map((item, i) => (
                                       <div
                                          key={i}
                                          className={`dropdown-item ${
                                             selectedCategory === item
                                                ? 'active'
                                                : ''
                                          }`}
                                          onClick={() => {
                                             setSelectedCategory(item)
                                             onSetLocalData(item)
                                          }}
                                       >
                                          {item}
                                       </div>
                                    ))}
                                 </div>
                              )}
                           </div>
                        </div>
                     )}
                  </div>
               )}
               <div className="row">
                  <div className="col-12 col-lg-7">
                     <div className=" news-detials-top-sect position-relative">
                        <div className=" news-details-image-section m-0">
                           <img
                              className={`text-center m-auto ${
                                 !newsDetails?.news_detail?.image_url
                                    ? 'news-original-logo'
                                    : ''
                              }`}
                              src={
                                 newsDetails?.news_detail?.image_url
                                    ? newsDetails?.news_detail?.image_url
                                    : '/assets/image/logo-se.png'
                              }
                              onError={(e) => {
                                 e.target.onerror = null // Prevent infinite loop
                                 e.target.src = '/assets/image/logo-se.png'
                                 e.target.classList.add('news-original-logo')
                              }}
                              alt={newsDetails?.news_detail?.re_original_title}
                           />
                        </div>
                        <div className="img-wrap-bg"></div>
                        <div className="news-details-content-section pb-1">
                           <h1 className="section_heading_title news-detail-title tech_title text-start my-0">
                              {newsDetails?.news_detail?.re_original_title}
                           </h1>
                           <div className="hz-news-line my-3"></div>
                           <div className="news-icon d-flex gap-3">
                              <Link
                                 target="_blank"
                                 href={`http://www.linkedin.com/shareArticle?mini=true&amp;url=${process.env.NEXT_PUBLIC_DOMAIN_NAME}/news-room/${newsDetails?.news_detail?.slug}&amp;title=${newsDetails?.news_detail?.re_original_title}`}
                                 className="social-icon-bg"
                              >
                                 <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <path
                                       d="M3.86654 15.0152H0.766803V5.04875H3.86654V15.0152ZM2.30014 3.71542C1.3332 3.71542 0.533203 2.88182 0.533203 1.88182C0.533203 0.915418 1.3332 0.115417 2.30014 0.115417C3.2996 0.115417 4.10014 0.915418 4.10014 1.88182C4.10014 2.88182 3.30014 3.71542 2.30014 3.71542ZM15.4335 15.0152H12.3668V10.1821C12.3668 9.01515 12.3332 7.54848 10.7332 7.54848C9.1332 7.54848 8.90014 8.78208 8.90014 10.0818V15.0152H5.79987V5.04875H8.7668V6.41515H8.79987C9.23347 5.64875 10.2335 4.81515 11.7332 4.81515C14.8665 4.81515 15.4665 6.88182 15.4665 9.54848V15.0152H15.4335Z"
                                       fill="#1F473E"
                                    />
                                 </svg>
                              </Link>
                              <Link
                                 target="_blank"
                                 href={`https://www.facebook.com/sharer/sharer.php?u=${process.env.NEXT_PUBLIC_DOMAIN_NAME}/news-room/${newsDetails?.news_detail?.slug}&amp;title=${newsDetails?.news_detail?.re_original_title}`}
                                 className="social-icon-bg"
                              >
                                 <svg
                                    width="16"
                                    height="15"
                                    viewBox="0 0 16 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <path
                                       d="M15.4665 7.54845C15.4665 3.42472 12.1236 0.0817871 7.99987 0.0817871C3.87614 0.0817871 0.533203 3.42472 0.533203 7.54845C0.533203 11.0503 2.94387 13.9885 6.19614 14.7954V9.83005H4.6564V7.54845H6.19614V6.56499C6.19614 4.02365 7.346 2.84605 9.84147 2.84605C10.3145 2.84605 11.1305 2.93885 11.4644 3.03165V5.09992C11.2884 5.08125 10.9823 5.07219 10.602 5.07219C9.37747 5.07219 8.9044 5.53619 8.9044 6.74152V7.54845H11.3433L10.9241 9.83005H8.9044V14.9607C12.6015 14.5138 15.4665 11.3655 15.4665 7.54845Z"
                                       fill="#1F473E"
                                    />
                                 </svg>
                              </Link>
                              <Link
                                 target="_blank"
                                 href={`https://twitter.com/intent/tweet?url=${process.env.NEXT_PUBLIC_DOMAIN_NAME}/news-room/${newsDetails?.news_detail?.slug}&amp;text=${newsDetails?.news_detail?.re_original_title}`}
                                 className="social-icon-bg"
                              >
                                 <svg
                                    width="14"
                                    height="15"
                                    viewBox="0 0 14 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <path
                                       d="M8.24083 6.52758L13.0979 0.881714H11.947L7.72936 5.78411L4.36136 0.881714H0.476562L5.5699 8.29505L0.476562 14.215H1.6275L6.08083 9.03851L9.63816 14.215H13.523L8.24083 6.52758ZM6.6643 8.36011L6.14803 7.62198L2.0419 1.74838H3.81043L7.12403 6.48811L7.6403 7.22625L11.948 13.3878H10.18L6.6643 8.36011Z"
                                       fill="#1F473E"
                                    />
                                 </svg>
                              </Link>
                           </div>
                        </div>
                     </div>
                     <p className="section_desc  news-content">
                        {newsDetails?.news_detail?.re_content}
                     </p>
                     <div className="author-section">
                        {/* <p>Published By : {newsDetails?.author}</p> */}
                        <p>Sources : {newsDetails?.news_detail?.news_from}</p>
                        <p>
                           Published On :{' '}
                           {newsDetails?.news_detail?.created_at &&
                              new Date(
                                 newsDetails?.news_detail.created_at
                              ).toLocaleDateString('en-US', {
                                 year: 'numeric',
                                 month: 'short',
                                 day: '2-digit',
                                 hour: '2-digit',
                                 minute: '2-digit',
                                 hour12: false,
                              })}
                        </p>
                     </div>
                  </div>
                  <div className="col-12 col-lg-5">
                     {newsDetails?.latest_news &&
                        newsDetails?.latest_news?.length > 0 &&
                        newsDetails?.latest_news?.slice(0, 5).map((item, i) => {
                           return (
                              <ListNewsCard
                                 card={item}
                                 onRedirect={onRedirect}
                              />
                           )
                        })}
                  </div>
               </div>
               <Link
                  className="btn bez-fill-btn job-action-buttons"
                  href="/news-room"
               >
                  View All News
                  <svg
                     width="25"
                     height="25"
                     viewBox="0 0 25 25"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M14.2011 19.6006C14.0025 19.6018 13.808 19.5437 13.6425 19.4339C13.477 19.3241 13.3479 19.1675 13.2718 18.9841C13.1956 18.8007 13.1758 18.5987 13.2148 18.4039C13.2539 18.2092 13.3501 18.0305 13.4911 17.8906L18.7911 12.6006L13.4911 7.31061C13.3273 7.11931 13.2417 6.87324 13.2514 6.62156C13.2611 6.36988 13.3655 6.13114 13.5436 5.95305C13.7217 5.77496 13.9604 5.67062 14.2121 5.6609C14.4638 5.65118 14.7098 5.73679 14.9011 5.90061L20.9011 11.9006C21.0874 12.088 21.1919 12.3414 21.1919 12.6056C21.1919 12.8698 21.0874 13.1233 20.9011 13.3106L14.9011 19.3106C14.7149 19.4954 14.4635 19.5995 14.2011 19.6006Z"
                        fill="#F4F2F0"
                     ></path>
                     <path
                        d="M6.19527 19.6017C5.99664 19.6029 5.80218 19.5449 5.63666 19.4351C5.47114 19.3253 5.34206 19.1687 5.2659 18.9852C5.18973 18.8018 5.16992 18.5998 5.20899 18.4051C5.24806 18.2103 5.34424 18.0316 5.48527 17.8918L10.7853 12.6017L5.48527 7.31175C5.29697 7.12344 5.19118 6.86805 5.19118 6.60175C5.19118 6.33545 5.29697 6.08005 5.48527 5.89175C5.67357 5.70344 5.92897 5.59766 6.19527 5.59766C6.46157 5.59766 6.71697 5.70344 6.90527 5.89175L12.9053 11.8917C13.0915 12.0791 13.1961 12.3326 13.1961 12.5967C13.1961 12.8609 13.0915 13.1144 12.9053 13.3017L6.90527 19.3018C6.81265 19.3962 6.70221 19.4714 6.58033 19.5229C6.45846 19.5744 6.32758 19.6012 6.19527 19.6017Z"
                        fill="#F4F2F0"
                     ></path>
                  </svg>
               </Link>
            </div>
         </section>
         <ContactUsForm />
      </>
   )
}

export default NewsDetailsPage

const ListNewsCard = ({ card, onRedirect }) => (
   <div
      className="list-card mb-3"
      onClick={() => {
         onRedirect(card?.slug)
      }}
   >
      <div className="row g-0">
         <div className="col-8">
            <div className="list-card-body">
               <span className="news-label-list">{card.news_type}</span>
               <h5 className="list-card-title">{card.rewritten_title}</h5>
               <p className="list-card-text">
                  {card.re_content?.slice(0, 120)}...
               </p>
               <small className="news-meta">
                  {card.news_from || 'Unknown'} |{' '}
                  {new Date(card.created_at).toLocaleString('en-US', {
                     month: 'short',
                     day: '2-digit',
                     year: 'numeric',
                     hour: '2-digit',
                     minute: '2-digit',
                     hour12: false,
                  })}
               </small>
            </div>
         </div>
         <div className="col-4">
            <img
               src={card.image_url || '/assets/image/logo-new.png'}
               alt={card.rewritten_title}
               className={`list-image ${
                  card.image_url ? 'object-fit-cover' : 'object-fit-scale'
               } `}
               onError={(e) => {
                  e.target.src = '/assets/image/logo-new.png'
               }}
            />
         </div>
      </div>
   </div>
)
